import React from 'react';
import PropTypes from 'prop-types';

// Sale capsule in the image's top-left corner ("$5.00 OFF"). Only for coupons with no per-unit
// price to strike through (fixed amounts): a percentage coupon already shows on the price chip,
// a capsule next to it would duplicate it. Render inside `.card-img-top`, like PriceBadge.
const SaleBadge = (props) => <span className="card-sale">{props.children}</span>;

SaleBadge.propTypes = {
  children: PropTypes.node,
};

export default SaleBadge;
